module.exports = __webpack_public_path__ + "static/media/Project-Etc.1e9e8cdf.svg";